// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__c4-wJ","Button_dark":"Button_Button_dark__Lfmnj","Button_light":"Button_Button_light__ua6gs","Button_transparent":"Button_Button_transparent__vkqUq"};